<template>
    <div class="default-payment">
        <!--  Checkboxes for payment type-->
        <PublicOfferPaymentTypes
            v-if="showCheckboxes && !hasFirstPaid"
            :order="order"
            :payment-type="paymentType"
            :loading="paymentUpdateLoading"
            :paymentParts="paymentParts"
            @change:paymentType="$emit('change:paymentType', $event)"
        />

        <!-- Notification about next payment date -->
        <PublicOfferOrderNextPayment v-if="showPartialPrice && hasNextPayment" :date="hasNextPayment" />

        <!-- Subscription info -->
        <PublicOfferSubscriptionInfo v-if="order.has_subscription && order.subscription_info" :order="order" />

        <!-- Merchants select -->
        <template v-if="severalMerchants">
            <default-title key="title" large class="mt-20 mb-10">
                {{ t("payments.integrations.title") }}:
            </default-title>
            <PublicOfferOrderMerchants
                key="merchantsList"
                :merchants="merchants"
                :selected="selectedMerchant"
                @select="$emit('selectedMerchant:change', $event)"
            />
        </template>

        <PublicOfferAuth
            :order-id="order.id"
            class="mt-20"
            @auth="$emit('handleAuth', $event)"
            v-if="displayOfferAuth"
        />

        <template v-else-if="displayButton">
            <!-- Access button -->
            <DefaultButton
                size="x-large"
                :text="accessButtonTitle"
                :background="'blue'"
                :disabled="severalMerchants ? !selectedMerchant : false"
                class="full-width mt-20"
                @click="handleClick"
            />

            <!-- Terms -->
            <p v-if="order.policy" v-html="order.policy" key="terms" class="public-offer-terms mt-20"></p>
            <p v-else
               v-html="t('step_start.cabinet_policy', {
                   data_processing_agreement: this.getLink('privacy-policy'),
                   terms_and_conditions: this.getLink('terms-and-conditions')
               })"
               key="terms"
               class="public-offer-terms mt-20"
            ></p>

        </template>
    </div>
</template>

<script>
import DefaultButton from "@components/Buttons/DefaultButton.vue"
import DefaultTitle from "@components/Typography/DefaultTitle.vue"
import PublicOfferAuth from "./PublicOfferAuth.vue"
import PublicOfferOrderMerchants from "./PublicOfferOrderMerchants.vue"
import PublicOfferOrderNextPayment from "./PublicOfferOrderNextPayment.vue"
import PublicOfferPaymentTypes from "./PublicOfferPaymentTypes.vue"
import PublicOfferSubscriptionInfo from "./PublicOfferSubscriptionInfo.vue"

export default {
    props: {
        order: {
            type: Object,
            default: () => {}
        },
        selectedMerchant: {
            type: Object,
            default: null
        },
        auth: {
            type: Boolean,
            default: false
        },
        showPartialPrice: {
            type: Boolean,
            default: false
        },
        paymentUpdateLoading: {
            type: Boolean,
            default: false
        },
        severalMerchants: {
            type: Boolean,
            default: false
        },
        paymentParts: {
            type: Array,
            default: null
        },
        merchants: {
            type: Array,
            default: null
        },
        paymentType: {
            type: String,
            default: "full"
        }
    },
    name: "PublicOfferDefaultPayment",
    components: {
        PublicOfferAuth,
        PublicOfferSubscriptionInfo,
        PublicOfferOrderNextPayment,
        PublicOfferOrderMerchants,
        DefaultButton,
        DefaultTitle,
        PublicOfferPaymentTypes
    },
    data() {
        return {
            showAuth: false
        }
    },
    created() {
        if (!this.severalMerchants && this.merchants.length) {
            this.$emit("selectedMerchant:change", this.merchants[0])
        }
    },
    methods: {
        handleClick() {
            if (this.auth) {
                this.$emit("handlePaymentLinks")
            } else if (this.selectedMerchant?.is_pay_without_registration) {
                this.$emit("handlePaymentLinks")
            } else {
                this.showAuth = true
            }
        },
        getLink(path) {
            return `${window.app_url}${path}`
        }
    },
    computed: {
        displayButton() {
            return this.order.payment_links.length || !this.auth
        },
        displayOfferAuth() {
            return this.showAuth && !this.auth && !this.selectedMerchant?.is_pay_without_registration
        },
        accessButtonTitle() {
            if (this.order.has_subscription) {
                let key = this.order.count_paid_payment ? "payments.extend" : "subscribe"
                return this.t(key)
            } else if (this.order.is_free) {
                return this.t("payments.start")
            } else if (
                (this.order.fields && this.order.unfilled) ||
                (!this.auth &&
                    this.severalMerchants &&
                    this.selectedMerchant &&
                    !this.selectedMerchant?.is_pay_without_registration)
            ) {
                return this.t("expert.next")
            } else {
                return this.t("payments.pay")
            }
        },
        firstLink() {
            return (
                this?.order?.payment_links && this?.order?.payment_links.length && this?.order?.payment_links[0]?.link
            )
        },
        showCheckboxes() {
            return (
                this.order.offer.is_pay_by_equal_parts ||
                this.order.offer.is_pay_by_specified_schedule ||
                this.order.offer.is_bank_credit_allowed
            )
        },
        hasFirstPaid() {
            return this.order.first_paid_at
        },
        hasNextPayment() {
            return this.paymentParts.length && this.paymentParts[0].next_payment_at
        },
        hasAmount() {
            return this?.order?.price_info?.price?.amount
        }
    }
}
</script>

<style scoped lang="sass">

</style>
